export default {
    title: 'Xcontact agente',
    badge: 'Distintivo',
    close: 'Cerrar',
    Pesquisar: 'Buscar',
    pesquisarAtendimentos: 'Buscar atendimientos',
    resultadoPesquisa: 'Resultado de Busqueda',
    isRequired: 'Obligatorio',
    atendimentosDoCliente: 'Atendimientos del cliente',
    atendimentosAtivos: 'Atendimientos activos',
    ultimosAtendimentos: 'Últimos atendimientos',
    indisponivel: 'Indisponible',
    fraseEncerramento: 'Desea cerrar este atendimiento?',
    legenda: `Título`,
    pesquisarContatos: 'Buscar contactos',
    atendimentos: 'Atendimientos',
    ligacoes: 'Llamadas',
    historico: 'Historial',
    contatos: 'Contactos',
    minhasFilas: 'Mis Colas',
    fraseInicial: '¡ La solución completa para la gestión de flujos de atendimientos Multi Canales !',
    classificacao: 'Clasificación',
    classificar: 'Clasificar',
    cancelar: 'Cancelar',
    duracao: 'Duración',
    ligar: 'Llamar',
    linhas: 'Líneas',
    janeiro: 'Enero',
    fevereiro: 'Febrero',
    marco: 'Marzo',
    abril: 'Abril',
    maio: 'Mayo',
    junho: 'Junio',
    julho: 'Julio',
    agosto: 'Agosto',
    setembro: 'Septiembre',
    outubro: 'Octubre',
    novembro: 'Noviembre',
    dezembro: 'Diciembre',
    naoFoiPossivelCompletarALigacao: 'No se pudo completar la llamada',
    naoFoiPossivelCompletarALigacaoOcupado: 'Numero ocupado',
    fechar: 'Cerrar',
    novaLigacao: 'Nueva llamada',
    atender: 'Contestar',
    recusar: 'Cortar',
    fila: 'Cola',
    UniqueId: 'Identificación única',
    O: 'El',
    inicouUmaChamada: 'inicio una llamada',
    ramal: 'Extensión',
    do: 'de',
    tocando: 'llamando',
    transferencia: 'Transferencia',
    eObrigatorio: 'Es obligatorio',
    configuracoes: 'Configuración',
    oSeuClientePrecisaSerAtualizado: '¡Tu cliente necesita estar actualizado!',
    atualizacaoEncontrada: '¿Actualización encontrada, le gustaría actualizar ahora?',
    instalandoAtualizacao: 'Instalando actualización',
    atualizacaoInstaladaComSucesso: 'Actualización instalada con éxito cerrando el cliente',
    itemIsRequired: 'El artículo es requerido',
    atendimentosPendentes: 'Asegúrese de que no haya llamadas pendientes',
    AoFecharoSistemaOAgenteSeraRemovidoDeTodasAsFilas: '¡Al cerrar el sistema, el agente será removido de todas las colas!',
    subClassificacao: 'Sub Clasificación',
    observacao: 'Observacion',
    sim: 'Si',
    nao: 'No',
    Sim: 'Si',
    Nao: 'No',
    novaLigacao: 'Nueva llamada',
    discar: 'Marcar',
    ok: 'Ok',
    anexar: `Adjuntar`,
    digiteAqui: `Marque aqui...`,
    fraseNenhumaFilaVoz: 'Usted no está registrado en ninguna cola de Voz',
    fraseNenhumaFilaEmail: 'Usted no está registrado en ninguna cola de Email',
    fraseNenhumaFilaWhatsApp: 'Usted no está registrado en ninguna cola de WhatsApp',
    transferencia: 'Transferencia',
    transferir: 'Transferir',
    novoEmail: 'Nuevo Email',
    novoWhatsApp: 'Nuevo WhatsApp',
    continuar: 'Continuar',
    encerrarAtendimento: `Terminar atendimiento`,
    classificarAtendimento: `Clasificar atendimiento`,
    transferirAtendimento: `Transferir atendimiento`,
    adicionarArquivos: `Adicionar archivos`,
    desligar: 'Cortar',
    filaUnica: `Cola`,
    pausar: 'Pausar',
    mensagemApagada: `Mensaje eliminado`,
    removerPausa: 'Remover pausa',
    desativar: 'Desactivar',
    ativar: 'Activar',
    ligacoesAtivas: 'Llamadas activas',
    fraseSelecioneLigacao: 'Selecione una llamada o informe el destino',
    informeUmNumero: 'Informe un número',
    tipo: 'Tipo',
    configuracao: 'Configuraçion',
    enderecoXcontact: 'Dirección del Xcontact',
    salvar: 'Guardar',
    senha: 'Clave',
    entrar: 'Entrar',
    usuario: 'Usuario',
    login: {
        title: 'Login',
        name: 'Nombre',
        password: 'Clave',
        btLogin: 'Entrar',
        loginFail: 'Usuario o clave inválido',
    },
    dataIterator: {
        noResultsText: 'Ningun dato encontrado',
        loadingText: 'Cargando items...',
    },
    dataTable: {
        itemsPerPageText: 'Lineas por página:',
        ariaLabel: {
            sortDescending: ': Ordenado decrescente. Active para remover el ordenamiento.',
            sortAscending: ': Ordenado crescente. Active para ordenar decreciente.',
            sortNone: ': No ordenado. Active para ordenar creciente.',
        },
        sortBy: 'Ordenar por',
    },
    dataFooter: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageAll: 'Todos',
        nextPage: 'Siguiente página',
        prevPage: 'Página anterior',
        firstPage: 'Primera página',
        lastPage: 'Última página',
        pageText: '{0}-{1} de {2}',
    },
    datePicker: {
        itemsSelected: '{0} selecionado(s)',
    },
    noDataText: 'No hay datos disponíbles',
    carousel: {
        prev: 'Vita anterior',
        next: 'Próxima vista',
        ariaLabel: {
            delimiter: 'Slide {0} de {1} do carrossel',
        },
    },
    calendar: {
        moreEvents: 'Mas {0}',
    },
    fileInput: {
        counter: '{0} archivo(s)',
        counterSize: '{0} archivo(s) ({1} en total)',
    },
    timePicker: {
        am: 'AM',
        pm: 'PM',
    },
    queue: "Cola",
    queues: "Colas",
    agentes: "Agentes",
    DispositivoDeEntrada: "Dispositivo de entrada",
    DispositivoDeSaida: "Dispositivo de salida",
    DispositivoDeAlarme: "Dispositivo de llamada",
    dadosDeIntegracao: "Datos de integración",
    nome: "Nombre",
    Nome: "Nombre",
    assunto: "tema",
    instancia: "ejemplo",
    numero: "número",
    ajusteDeAudio: "Configuraciones de audio",
    agente: "agente",
    pesquiseAqui: "pesquise aqui",
    reproduzirAudioNasNotificaçõesDeMensagens: "reproducir audio en notificaciones de mensajes?",
    emAtendimento: "En atendimiento",
    finalizado: "Finalizado",
    disponivel: 'Disponible',
    responder: 'responder',
    apagarMensagem: 'apagar mensaje',
    responderATodos: 'Responder a todos',
    encaminhar: 'Encaminar',
    contato: 'contacto',
    data: 'datos',
    sentido: 'sentido',
    visualizar: 'visualizar',
    ligar: 'Llamar',
    entrantes: 'Entrantes',
    saintes: 'Salientes',
    atendidas: 'Atendidas',
    naoAtendidas: 'No atendidas',
    sainte: 'saliente',
    entrante: 'Entrante',
    enderecoDoXcontact: 'Dirección de Xcontact',
    enderecoPabx: 'Dirección Pabx',
    habilitarNotificacaoes: 'habilitar  notificaciones?',
    dadosIndisponiveis: 'Información no disponible',
    obrigaClassificarLigacao: 'Obligar a clasificar llamadas',
    autoAtendimento: 'Auto atendimiento',
    urlintegracao: 'Url Integración',
    selecioneohorario: 'Seleccione un horario',
    descricao: 'Descripción',
    addUserConference: 'Adicionar participantes',
    Alerta: 'Alerta!',
    ultimoAgente: 'ultimo agente',
    Encerrado: 'Encerrado',
    Encerrado: 'Encerrado',
    Entrou: 'En Atendimiento',
    PreAtendimento: 'Pre Atendimiento',
    ConexaoPerdida: 'Conexión Perdida',
    DesconectadoDoServidor: "Desconectado",
    ConexaoEstabelecida: "Conexión establecida",
    ConectadoAoServidor: "Conectado con servidor!",
    FilaDeEspera: "Cola de espera",
    editarContato: "Editar contacto",
    Agendamentos: 'Agendamiento',
    Naofoipossivelcompletaraligacao: 'No se pudo completar la llamada',
    fraseAoFechar1: 'Asegúrese de que no haya llamadas pendientes.',
    fraseAoFechar2: '¡Al cerrar el sistema, el agente será removido de todas las colas!',
    fraseCampoObrigatorio: 'El artículo es requerido',
    transferir: "Transferir",
    configuracoesDeVoz: 'Configuración de audio',
    urlIntegracao: 'Url Integración',
    frasePerdaConexao: 'Conexión Perdida',
    enviarTemplate: 'Enviar template',
    salvarCredenciais: 'Guardar credenciais'

















}
